import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { AppService } from '@app/app.service';
import { Customer } from '@api/index';
import { LanguageModalComponent } from '@shared/language-modal/language-modal.component';
import { unsubscribeMixin } from '../unsubscribe';
import { AuthService } from '../auth/auth.service';
import { UserRoleEnum } from '@app/admin/user/model/user.model';
import { TranslateConfigService } from '../translate-config.service';
import { CurrentUser } from '../auth/current-user';
import { UserReset } from '@store/user';
import { Permissions } from '@shared/models/enums/permissions.enum';

@Component({
  selector: 'flow-nav-settings',
  templateUrl: './nav-settings.component.html',
  styleUrls: ['./nav-settings.component.scss'],
})
export class NavSettingsComponent extends unsubscribeMixin() implements OnInit {
  @Input() adminUser!: { id: number; name: string };
  @Input() currentUser!: CurrentUser;
  @Input() initials!: string;
  @Input() customers!: Customer[];
  @Output() customerChange = new EventEmitter<number>();
  @Output() closeNavSettings = new EventEmitter<boolean>();

  selectedCustomer: Customer;
  isAdmin: boolean = false;
  currentLanguage: string;
  Permissions = Permissions;

  constructor(
    private router: Router,
    private authService: AuthService,
    public appService: AppService,
    private dialog: MatDialog,
    private transalteConfigService: TranslateConfigService,
    private store: Store
  ) {
    super();
  }

  ngOnInit(): void {
    const user = this.authService.userData;
    this.isAdmin = user?.roleId === UserRoleEnum.Admin;
    this.currentLanguage = this.transalteConfigService.currentLanguage;
    this.setSelectedCustomer(user);
  }

  logout(): void {
    this.authService.logout();
    this.store.dispatch(UserReset());
    this.router.navigateByUrl('/login');
    this.closeNavSettings.emit(true);
  }

  closeNav() {
    this.closeNavSettings.emit(true);
  }

  onCustomerChange(customer: number) {
    const newCustomerId = customer === -1 ? null : customer;
    this.customerChange.emit(newCustomerId);
  }

  setSelectedCustomer(currentUser) {
    const id = currentUser.currentCustomerId || currentUser.customerId;
    const customer = this.customers?.find(c => c.id === id) || this.adminUser;
    this.selectedCustomer = customer;
  }

  openLanguageModal(): void {
    this.closeNavSettings.emit(true);
    this.dialog.open(LanguageModalComponent, {
      panelClass: 'language-modal',
      width: '600px',
      data: {
        changeLanguage: (lang: string) => this.changeLanguage(lang),
      },
    });
  }

  changeLanguage(lang: string) {
    const newLanguage = lang;
    this.transalteConfigService.changeLanguage(newLanguage);
    this.currentLanguage = newLanguage;
  }
}
